import { Component, OnInit, Input } from '@angular/core';
import { PackageModel } from 'src/app/model/stripe-models/product/package-model';

@Component({
    selector: 'app-tarif-card-selected',
    templateUrl: './tarif-card-selected.component.html',
    styleUrls: ['./tarif-card-selected.component.scss'],
    standalone: false
})
export class TarifCardSelectedComponent implements OnInit {
  @Input() plan!: PackageModel;

  constructor() { }

  ngOnInit(): void {
  }

}
